import type { WebPortalVariableMappingEntry } from '@/services/webPortalTemplatesService'

export function buildWebPortalVariableMapping(
  count: number,
  previous: WebPortalVariableMappingEntry[] = [],
): WebPortalVariableMappingEntry[] {
  return Array.from({ length: count }, (_, index) => {
    const position = index + 1
    const existing = previous.find((item) => item.position === position)
    if (existing) {
      return { ...existing, position, source_type: 'variable' }
    }
    return { position, source_type: 'variable', source_key: '' }
  })
}

export function normalizeWebPortalMappingFromApi(
  mapping: WebPortalVariableMappingEntry[] | undefined,
): WebPortalVariableMappingEntry[] {
  return (mapping ?? []).map((entry) => ({
    position: entry.position,
    source_type: 'variable',
    source_key: entry.source_key || '',
    ...(entry.fallback_text ? { fallback_text: entry.fallback_text } : {}),
  }))
}

export function normalizeWebPortalMappingForApi(
  mapping: WebPortalVariableMappingEntry[],
): WebPortalVariableMappingEntry[] {
  return mapping
    .filter((entry) => entry.source_key)
    .map((entry) => ({
      position: entry.position,
      source_type: 'variable' as const,
      source_key: entry.source_key,
      ...(entry.fallback_text ? { fallback_text: entry.fallback_text } : {}),
    }))
}
